import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Checkbox, FormFileUpload } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, documentCategories, initialValues, t }) => {

	const documentData = initialValues && initialValues.document && {
		filename: initialValues.document.friendlyFilename,
		url: initialValues.document.url
	};
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='documentCategoryId' component={Input} horizontal componentClass='select' label={t('DocumentForm_Category')}>
				<option />
				{ui.makeOptionValues(documentCategories)}
			</Field>
			<Field name='name' component={Input} disabled={isReadonly} horizontal required label={t('DocumentForm_Name')} validate={[validators.required]} />
			<Field name='documentId' component={FormFileUpload} disabled={isReadonly} horizontal label={t('DocumentForm_File')} initialData={documentData} />
			<Field name='isOnline' component={Checkbox} disabled={isReadonly} horizontal label={t('DocumentForm_IsOnline')} normalize={(v) => { return !!v }} />
			<FormActions horizontal>
				<Link to='/documentForms' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'documentForm', enableReinitialize: true })(withTranslation()(SettingsForm));
